// Copyright ©️ 2026 eVolve MEP, LLC

import './calendar.css';

import type { ComponentProps, CSSProperties } from 'react';

import type { Calendar } from '@mantine/dates';

export const highlightDayStyles: CSSProperties = {
  borderStyle: 'solid',
  borderWidth: 2,
  borderColor: 'var(--mantine-primary-color-5)',
};

export const calendarStyles: ComponentProps<typeof Calendar>['styles'] = {
  monthsListControl: {
    width: '100%',
    height: '100%',
  },
  yearsListControl: {
    width: '100%',
    height: '100%',
  },
  levelsGroup: {
    width: '100%',
    height: '100%',
  },
  monthsList: {
    height: '100%',
  },
  yearsList: {
    height: '100%',
  },
  calendarHeader: {
    maxWidth: 'none',
    width: '100%',
  },
  calendarHeaderLevel: {
    fontSize: 16,
  },
  weekdaysRow: {
    width: '100%',
    display: 'flex',
  },
  weekday: {
    flex: 1,
  },
  month: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    height: '100%',
    overflow: 'hidden',
  },
  monthTbody: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    overflow: 'hidden',
  },
  monthRow: {
    display: 'flex',
    flex: 1,
    overflow: 'hidden',
  },
  monthsListRow: {
    display: 'flex',
    width: '100%',
    height: '25%',
  },
  yearsListRow: {
    display: 'flex',
    width: '100%',
    height: '25%',
  },
  monthCell: {
    flex: 1,
    verticalAlign: 'initial',
    overflow: 'hidden',
    display: 'flex',
  },
  monthsListCell: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  yearsListCell: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  day: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    width: 'unset',
    height: 'unset',
    overflow: 'hidden',
    borderStyle: 'solid',
    borderColor: 'rgba(0,0,0,.2)',
    borderWidth: 1,
  },
};
